import React, { useState, useEffect } from "react";

import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Table,
  Card,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import * as actionCreators from "../../../../modules/actions/index";
import Loading from "../../../../hoc/Loading/Loading";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdFileUpload } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import Select from "react-select";
import { SURVEY_QUESTIONS } from "../../../../components/Survey/data";
import { BiX } from "react-icons/bi";
import { BsThreeDots } from "react-icons/bs";
import { isUrlValid, uploadPreview } from "../../../../utils/constants";
import { toastContainer } from "../../../../utils/toast";
import { WEB_GENERATE_ERROR_MESSAGE } from "../../data";
import DatePicker from "react-datepicker";
import {
  LayoutData,
  LayoutDataLines,
  LayoutHeadingShadow,
  LayoutHeadingShadowLeft,
  LayoutRowLines,
  LayoutRowShadow,
} from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import { isMobile } from "../../../../utils/deviceInfo";
import CheckBox from "rc-checkbox";
import EmptyTable from "../../../../components/EmptyTable/EmptyTable";
import TrivvyImmediateRewardToast from "../../../../components/TrivvyToast/TrivvyImmediateRewardToast";
import { withRouter } from "react-router";

function TrivvyHolidayTemplates({
  open,
  onClose,
  addTrivvySuccessFromTemplates,
  handleBack,
  history
}) {
  const [templates, setTemplates] = useState([]);
  const [showTrivvy, setShowTrivvy] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(url.getTrivvyHolidayTemplates)
      .then(({ data }) => {
        setLoading(false);
        const selected = data.data.map((x) => ({ ...x, isSelected: true }));
        setTemplates(selected);
      })
      .catch((err) => {
        toastContainer("Error fetching templates", "error");
        setLoading(false);
      });
  }, []);

  const tableCols = {
    name: 7,
    date: 3,
    action: 2,
  };
  const tableColsMobile = {
    name: 7,
    date: 6,
    action: 6,
  };

  const selectTemplate = (value, name) => {
    const allTemplates = [...templates];
    const templateIndex = templates.findIndex((x) => x.name == name);

    allTemplates[templateIndex].isSelected = value;

    setTemplates(allTemplates);
  };

  const getTemplateDate = (item) => {
    if (item.templateMeta) {
      if (item.templateMeta.date) {
        return item.templateMeta.date
          .replace(/\d/g, "")
          .replace("rd", "")
          .replace("Between", "")
          .replace("and", "-");
      } else {
        return moment()
          .month(item.templateMeta.month - 1)
          .format("MMMM");
      }
    } else {
      return "-";
    }
  };

  const generateTrivvysFromTemplates = () => {
    const selectedData = templates.filter((x) => x.isSelected);

    if (selectedData.length) {
      axios
        .post(url.generateTrivvysFromTemplates, { selectedData })
        .then(({ data }) => {
          addTrivvySuccessFromTemplates(data.data.trivvys);
          const idsArr = data.data.trivvys.map(x => x._id)
          toastContainer(<TrivvyImmediateRewardToast history={history} noPlanCustomMessage={"Trivvys generated from Templates"} trivvyIds={idsArr}  />,"success")
          // toastContainer("Trivvys generated from Templates", "success");
        })
        .catch((err) => {
          toastContainer("Error generating trivvys from templates", "error");
        });
    } else {
      toastContainer("Please select templates", "error");
    }
  };

  const allSelected = templates.findIndex((x) => !x.isSelected) == -1;

  return (
    <div>
      {showTrivvy && (
        <Modal isOpen={showTrivvy.name.length > 0}>
          <ModalHeader toggle={() => setShowTrivvy(null)}>
            {showTrivvy.name}
          </ModalHeader>

          <ModalBody
            className={"p-3"}
            style={{ height: "400px", overflowY: "auto" }}
          >
            {showTrivvy.questions &&
              showTrivvy.questions.map((que) => {
                const correctAns =
                  que.correct_options &&
                  que.correct_options[0] &&
                  que.correct_options[0].text;
                return (
                  <Card className="w-100 my-3 p-3">
                    <h5>{que.question_text}</h5>

                    <div className="fonnt-weight-bold">Options:</div>

                    <ul>
                      {que.options.map((x) => {
                        return <li>{x.text}</li>;
                      })}
                    </ul>

                    {correctAns && (
                      <h6 className="text-success">
                        Correct Answer : {correctAns}
                      </h6>
                    )}
                  </Card>
                );
              })}
          </ModalBody>
        </Modal>
      )}

      {templates && templates.length ? (
        <div>
          <div className="my-2 d-flex align-items-center">
            <CheckBox
              className="ml-4 trivvy_template_modal_image_checkbox relative-place-chkbox"
              checked={allSelected}
              onChange={(e) => {
                if (e.target.checked) {
                  const data = [
                    ...templates.map((x) => ({ ...x, isSelected: true })),
                  ];
                  setTemplates(data);
                } else {
                  const data = [
                    ...templates.map((x) => ({ ...x, isSelected: false })),
                  ];
                  setTemplates(data);
                }
              }}
            />

            <span className="ml-2">
              {allSelected ? "Deselect all" : "Select all"}
            </span>
          </div>

          {!isMobile ? (
            <div className="trivia_survey_list_table templates_table px-3 trivia_survey_library_table">
              <div className="my-4 trivia_survey_list_table_contents ">
                <LayoutRowShadow className="row-shadow-header-no-shadow px-15em mx-0">
                  <LayoutHeadingShadow
                    className={"text-center"}
                    colWidth={tableCols.name}
                  >
                    Name
                  </LayoutHeadingShadow>
                  <LayoutHeadingShadow
                    className={"text-center d-block"}
                    colWidth={tableCols.date}
                  >
                    Month
                  </LayoutHeadingShadow>

                  <LayoutHeadingShadow
                    className={"justify-content-center"}
                    colWidth={tableCols.action}
                  ></LayoutHeadingShadow>
                </LayoutRowShadow>
                <div
                  className={
                    isMobile
                      ? "trivia_survey_list_table_contents_scroll_modal"
                      : "trivia_survey_list_table_contents_scroll"
                  }
                >
                  {!isMobile &&
                    templates.map((item, idx) => {
                      return (
                        <LayoutRowShadow key={idx}>
                          <LayoutData
                            colWidth={tableCols.name}
                            className="cursor-pointer"
                          >
                            <div className="mx-2">
                              <CheckBox
                                style={{ top: "10px" }}
                                className="trivvy_template_modal_image_checkbox"
                                checked={item.isSelected}
                                type="checkbox"
                                onClick={(e) => {
                                  selectTemplate(e.target.checked, item.name);
                                }}
                              />
                            </div>
                            <div className="survey-item-title">{item.name}</div>
                          </LayoutData>

                          <LayoutData
                            colWidth={tableCols.date}
                            className="cursor-pointer"
                          >
                            {getTemplateDate(item)}
                          </LayoutData>

                          <LayoutData
                            className="text-center"
                            colWidth={tableCols.action}
                          >
                            <Button
                              color="primary"
                              onClick={() => {
                                setShowTrivvy(item);
                              }}
                            >
                              View
                            </Button>
                          </LayoutData>
                        </LayoutRowShadow>
                      );
                    })}
                </div>
              </div>
            </div>
          ) : (
            <div className="trivia_table_mobile mt-4">
              <div
                className={
                  isMobile
                    ? "trivia_survey_list_table_contents_scroll_modal"
                    : "trivia_survey_list_table_contents_scroll"
                }
              >
                <Row>
                  <Col xs={5} className="px-0">
                    <Row>
                      <LayoutHeadingShadow
                        className={"justify-content-center"}
                        colWidth={12}
                      >
                        Name
                      </LayoutHeadingShadow>
                    </Row>

                    {templates.map((item, idx) => {
                      return (
                        <Row key={idx} className={"planning-row-mobile-height"}>
                          <LayoutDataLines colWidth={12} noFlex>
                            <div>
                              <div className="mx-2">
                                <CheckBox
                                  style={{ top: "10px" }}
                                  className="trivvy_template_modal_image_checkbox"
                                  checked={item.isSelected}
                                  type="checkbox"
                                  onClick={(e) => {
                                    selectTemplate(e.target.checked, item.name);
                                  }}
                                />
                              </div>
                              <div
                                className="survey-item-title text-info"
                                style={{ marginLeft: "30px" }}
                              >
                                {item.name}
                              </div>
                            </div>
                          </LayoutDataLines>
                        </Row>
                      );
                    })}
                  </Col>
                  <Col xs={7} className="scrollable-action-table-row">
                    <LayoutRowLines className="row-scroll-width-s">
                      <LayoutHeadingShadow
                        className={"justify-content-center "}
                        colWidth={tableColsMobile.date}
                      >
                        Month
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={"justify-content-center "}
                        colWidth={tableColsMobile.action}
                      ></LayoutHeadingShadow>
                    </LayoutRowLines>

                    {templates.map((item, idx) => {
                      return (
                        <LayoutRowLines
                          key={idx}
                          className={`pl-tasks-row ${
                            isMobile ? "row-scroll-width-s" : ""
                          }`}
                        >
                          <LayoutDataLines
                            colWidth={tableColsMobile.date}
                            className="cursor-pointer"
                          >
                            {getTemplateDate(item)}
                          </LayoutDataLines>

                          <LayoutDataLines
                            className="text-center"
                            colWidth={tableColsMobile.action}
                          >
                            <Button
                              color="primary"
                              onClick={() => {
                                setShowTrivvy(item);
                              }}
                            >
                              {" "}
                              View{" "}
                            </Button>
                          </LayoutDataLines>
                        </LayoutRowLines>
                      );
                    })}
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="my-5 py-5">
          {loading ? (
            <h5 className="text-center"> Loading templates ... </h5>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <EmptyTable
                title="No templates found"
                subtitle={"There were no templates found to create a trivvy."}
              />{" "}
            </div>
          )}
        </div>
      )}

      <ModalFooter>
      <Button
            className="w-150 mr-3"
            size="sm"
            onClick={handleBack}
            style={{
              height:"33px"
            }}
          >
            Back
          </Button>
        {templates && templates.length ? (
          <Button
            className="trivia-action-button-main mr-4 trivv-create-btn"
            size="sm"
            onClick={() => {
              generateTrivvysFromTemplates();
            }}
            disabled={templates.findIndex((x) => x.isSelected) == -1}
          >
            Submit
          </Button>
        ) : (
          ""
        )}
      </ModalFooter>
    </div>
  );
}


const mapStateToProps = (state) => {
  return {
   
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
   

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TrivvyHolidayTemplates));
